import { 
    Street, 
    MyCol} from "../../styles/MapStyles";

const VerticalStreet = ({streetname, maxHeight, minHeight}) => {

  let multiple = 5;
  if (maxHeight >= 1000 && streetname !== "Union") {
    multiple = 2;
  } else 
  if(maxHeight < 1000 && maxHeight >= 300) {
    multiple = 2;
  } else if(maxHeight <= 300) {
    multiple = 0;
  }
    return (
        <MyCol xl={2} 
          style={{
            width: "30px", 
            display: "grid", 
            justifyContent: "center", 
            height: `${maxHeight}px`,
            marginTop: "-5px", 
          }}
        >
          <Street>
            {[...Array(4)].map((_, index, array) => (
              <div
                key={`top-div-${index}`}
                style={{
                  backgroundColor: "#C4E1FF",
                  width: "3px",
                  marginTop: "10px",
                  height: "15px",
                  marginRight: index === array.length - 1 ? "0px" : "6px", // No margin on the last div
                  float: "left",
                }}
              ></div>
            ))}
              <div style={{
                writingMode: "vertical-rl", 
                transform: "rotate(180deg)",
                color: "white",
                fontStyle: "bold",
                marginLeft: "2px",
                letterSpacing: "7px", 
                height: maxHeight-5-(streetname.length*multiple),
                textAlign: "center"}}>
                  {maxHeight > 300 && (
                  streetname.toUpperCase())}
              </div>
            {[...Array(4)].map((_, index, array) => (
              <div
                key={`bottom-div-${index}`}
                style={{
                  backgroundColor: "#C4E1FF",
                  width: "3px",
                  marginTop: "-10px",
                  height: "15px",
                  marginRight: index === array.length - 1 ? "0px" : "6px", // No margin on the last div
                  float: "left",
                  marginBottom: "10px",
                }}
              ></div>
            ))}
          </Street>
        </MyCol>
      );
};

export default VerticalStreet;